import type { JSX } from "preact";

type ButtonProps = JSX.HTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "ghost";
};

export function BrutalButton({
  variant = "primary",
  className = "",
  ...props
}: ButtonProps) {
  let variantClasses = "";
  if (variant === "primary") {
    variantClasses =
      "bg-brutal-orange text-black dark:text-gray-900 hover:bg-brutal-orange-hover";
  } else if (variant === "secondary") {
    variantClasses =
      "bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-gray-800";
  } else if (variant === "ghost") {
    variantClasses =
      "bg-transparent text-gray-900 dark:text-gray-100 hover:bg-orange-50 dark:hover:bg-gray-800";
  }

  const base =
    "brutal-btn inline-flex items-center justify-center min-h-[2.5rem] px-5 py-2.5 font-semibold rounded-none border-2 border-black dark:border-gray-100";

  return (
    <button
      {...props}
      className={`${base} ${variantClasses} ${className}`.trim()}
    />
  );
}

type InputProps = JSX.HTMLAttributes<HTMLInputElement> & {
  type?: string;
};

export function BrutalInput({ className = "", type = "text", ...props }: InputProps) {
  const base =
    "brutal-input px-4 py-2.5 text-base rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100";

  return (
    <input
      {...props}
      type={type}
      className={`${base} ${className}`.trim()}
    />
  );
}

type SelectProps = JSX.HTMLAttributes<HTMLSelectElement>;

export function BrutalSelect({ className = "", ...props }: SelectProps) {
  const base =
    "brutal-input px-2 py-1.5 text-sm rounded-none border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100";

  return (
    <select
      {...props}
      className={`${base} ${className}`.trim()}
    />
  );
}

